import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";

export class DoctorDocHelpers {
  public static getFolderPath(doctorId: string | undefined): string {
    try {
      if (doctorId === undefined) throw new Error("doctorId is undefined");
      return `doctors/${doctorId}/docs/`;
    } catch (error: unknown) {
      appFaultModel.catchAppError("DoctorDocHelpers.getFolderPath", { doctorId }, error);
      throw error;
    }
  }
}
